import { render, staticRenderFns } from "./ToolbarComponent.vue?vue&type=template&id=449baacf&"
import script from "./ToolbarComponent.vue?vue&type=script&lang=js&"
export * from "./ToolbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarComponent.vue?vue&type=style&index=0&id=449baacf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports